module.exports = __webpack_public_path__ + "media/images/rank/silver-md-e803d1b1c300663ca1e1b8d3ba7f6307.svg";